/** Per-meter palette as arbitrary hex classes — the spicy-ui theme has no fuchsia/amber scales. */
type MeterPalette = {
  text: string;
  chip: string;
  strips: [string, string];
};

const METER_PALETTES: MeterPalette[] = [
  { text: "text-[#F472B6]", chip: "bg-[#F472B6]/20 text-[#F472B6]", strips: ["bg-[#7A2E5B]", "bg-[#5E2247]"] },
  { text: "text-[#60A5FA]", chip: "bg-[#60A5FA]/20 text-[#60A5FA]", strips: ["bg-[#2F4D8A]", "bg-[#243B6B]"] },
  { text: "text-[#FBBF24]", chip: "bg-[#FBBF24]/20 text-[#FBBF24]", strips: ["bg-[#7A5A1E]", "bg-[#5E4517]"] },
  { text: "text-[#4ADE80]", chip: "bg-[#4ADE80]/20 text-[#4ADE80]", strips: ["bg-[#2F6B45]", "bg-[#244F35]"] },
  { text: "text-[#9CA3AF]", chip: "bg-[#9CA3AF]/20 text-[#9CA3AF]", strips: ["bg-[#3F3F46]", "bg-[#2E2E33]"] },
];

const paletteAt = (meterIndex: number): MeterPalette => METER_PALETTES[meterIndex % METER_PALETTES.length];

/** Icon/label text color per meter index. */
const meterTextTint = (meterIndex: number): string => paletteAt(meterIndex).text;

/** Chip background+text pair per meter index (icon color at /20). */
const meterChipTint = (meterIndex: number): string => paletteAt(meterIndex).chip;

/** Two alternating strip shades per meter index. */
const meterStripShades = (meterIndex: number): [string, string] => paletteAt(meterIndex).strips;

/** Level bands get stronger from the first level to the last, as in the design spec. */
const STRIP_ALPHAS = ["38", "5C", "80", "A6", "CC", "E6"];

/** Inline strip shades derived from a meter's own `#rrggbb` color, one per level position. */
const meterColorStripShades = (color: string): string[] => STRIP_ALPHAS.map((alpha) => `${color}${alpha}`);

export { meterChipTint, meterColorStripShades, meterStripShades, meterTextTint };
